export const ADD_TO_CART = 'DRUGSTORE_CART/ADD_TO_CART';
export const REMOVE_FROM_CART = 'DRUGSTORE_CART/REMOVE_FROM_CART';
export const SET_LOADING = 'SET_LOADING';

export const ADD_TO_FAVORITES = 'DRUGSTORE_CART/ADD_TO_FAVORITES';
export const SET_CART_ITEM_COUNT = 'DRUGSTORE_CART/SET_CART_ITEM_COUNT';

export const FETCH_DRUGSTORES = 'DRUGSTORE_CART/FETCH_DRUGSTORES';
export const FETCH_DRUGSTORES_SUCCESS =
  'DRUGSTORE_CART/FETCH_DRUGSTORES_SUCCESS';
export const FETCH_DRUGSTORES_ERROR = 'DRUGSTORE_CART/FETCH_DRUGSTORES_ERROR';

export const SELECT_OFFER = 'DRUGSTORE_CART/SELECT_OFFER';

export const STORE_ORDER_REQUEST = 'DRUGSTORE_CART/STORE_ORDER_REQUEST';
export const STORE_ORDER_SUCCESS = 'DRUGSTORE_CART/STORE_ORDER_SUCCESS';
export const STORE_ORDER_ERROR = 'DRUGSTORE_CART/STORE_ORDER_ERROR';

export const FLUSH_ALL = 'DRUGSTORE_CART/FLUSH_ALL';

export const SET_LOCATION = 'DRUGSTORE_CART/SET_LOCATION';

export const SET_MAP_CENTER = 'DRUGSTORE_CART/SET_MAP_CENTER';

export const LOAD_MORE_OFFERS_REQUEST =
  'DRUGSTORE_CART/LOAD_MORE_OFFERS_REQUEST';
export const LOAD_MORE_OFFERS_SUCCESS =
  'DRUGSTORE_CART/LOAD_MORE_OFFERS_SUCCESS';
export const LOAD_MORE_OFFERS_ERROR = 'DRUGSTORE_CART/LOAD_MORE_OFFERS_ERROR';

export const PRELOAD_FORM_REQUEST = 'DRUGSTORE_CART/PRELOAD_FORM_REQUEST';
export const PRELOAD_FORM_SUCCESS = 'DRUGSTORE_CART/PRELOAD_FORM_SUCCESS';
export const PRELOAD_FORM_ERROR = 'DRUGSTORE_CART/PRELOAD_FORM_ERROR';

export const FLUSH_CONFIRM = 'DRUGSTORE_CART/FLUSH_CONFIRM';

export const SET_V_ERRORS = 'SET_V_ERRORS';
export const SET_LOADER = 'SET_LOADER';
